const projectsMessages = {
  en: {
    projects: "Other projects",
    consolidation: "Consolidation",
    consolidationDescription:
      "Participation in the data consolidation project of two telecommunications operators",
    consolidationJob:
      "Technologies: Sharepoint 2010, Visual Studio 2010, Javascript, html",
    portal: "Corporate portal",
    portalDescription:
      "Participation in the project of creating a corporate portal for a State Treasury company",
    portalJob: "Technologie: Sharepoint 2013, Visual Studio, Javascript, html",
    telephony: "Phone",
    telephonyDescription:
      "Design and development of an application for settling employee telephones",
    telephonyJob: "Technologies: ASP, CSS, Javascript, html",
    diary: "Sales diary",
    diaryDescription:
      "Design and implementation of an application as a closed information flow reporting current sales results in the T-Mobile network",
    diaryJob: "Technologies: Perl, CSS, Javascript, html, MS SQL",
    erp: "ERP",
    erpDescription:
      "Design and implementation of an ERP system for a medium-sized enterprise",
    erpJob:
      "Technologies: PHP, CSS, Javascript, jQuery, Bootstrap, html, MySQL, GIT, bash, docker",
    ecommerce: "e-commerce",
    ecommerceDescription:
      "Participation in a project to create a client application for a well-known cosmetology portal",
    ecommerceJob:
      "Technologies: PHP, CSS, Javascript, jQuery, Bootstrap, html, MySQL",
  },
  pl: {
    projects: "Inne projekty",
    consolidation: "Konsolidacja",
    consolidationDescription:
      "Udział w projekcie konsolidacji danych dwóch operatorów telekomunikacyjnych",
    consolidationJob:
      "Technologie: Sharepoint 2010, Visual Studio 2010, Javascript, html",
    portal: "Portal korporacyjny",
    portalDescription:
      "Udział w projekcie tworzenia portalu korporacyjnego dla spółki Skarbu Państwa",
    portalJob: "Technologie: Sharepoint 2013, Visual Studio, Javascript, html",
    telephony: "Telefon",
    telephonyDescription:
      "Projekt i wykonanie autorskie aplikacji służącej rozliczaniu telefonów pracowniczych",
    telephonyJob: "Technologie: ASP, CSS, Javascript, html",
    diary: "Dziennik sprzedaży",
    diaryDescription:
      "Zaprojektowanie i wdrożenie aplikacji jako zamknięty obieg informacji raportujący na bieżąco wyniki sprzedaży w sieci T-Mobile",
    diaryJob: "Technologie: Perl, CSS, Javascript, html, MS SQL",
    erp: "ERP",
    erpDescription:
      "Zaprojektowanie i wdrożenie systemu ERP dla średniego przedsiębiorstwa",
    erpJob:
      "Technologie: PHP, CSS, Javascript, jQuery, Bootstrap, html, MySQL, GIT, bash, docker",
    ecommerce: "e-commerce",
    ecommerceDescription:
      "Udział w projekcie tworzenia plikacji klienckiej znanego portalu kosmetologicznego",
    ecommerceJob:
      "Technologie: PHP, CSS, Javascript, jQuery, Bootstrap, html, MySQL",
  },
};
export default projectsMessages;
